<div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-relative tw-p-4">
  <div class="tw-flex tw-w-full tw-items-start tw-justify-between">
    <h5 class="tw-text-color-1 tw-mb-3">Enter Investment Details</h5>
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close(false)" aria-label="Close Dialog">
      <common-icons iconName="x" class="tw-w-6 tw-h-6 tw-text-primary-500 tw-cursor-pointer"
        aria-hidden="true"></common-icons>
    </button>
  </div>
  <p class="tw-para-2 tw-mb-4 tw-text-center">Enter the price at which you ordered the stock</p>
  <form
    class="tw-flex tw-w-full tw-flex-col tw-gap-y-4 tw-mb-[70px] tw-px-4 tw-pt-2.5 tw-overflow-hidden tw-overflow-y-auto tw-max-h-[400px]"
    [formGroup]="externalInvestmntFOrm" *ngIf="externalInvestmntFOrm">
    <ng-container
      *ngIf="(allInstruments | isExternalDialogCategoryAvailable:{section: data.section, category: 'cash'})">
      <ng-container formArrayName="cash" *ngFor="let stocks of getControlsArr('cash')?.controls; let i = index">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-y-5">
          <p class="tw-para-2 tw-w-[35%]">Equity</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Price</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Quantity</p>
          <p class="tw-para-2 tw-w-[15%] tw-text-right">Order Type</p>
        </div>
        <div class="tw-flex tw-w-full tw-items-center tw-gap-x-5 tw-pb-5 tw-border-b tw-border-b2" [formGroupName]="i">
          <h6 class="tw-w-[35%] tw-text-color-1">{{stocks.controls['tradingSymbol'].value}}</h6>
          <div class="tw-w-[25%] tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-text-color-2">
            {{stocks.controls['currentPrice'].value}}
          </div>
          <div class="tw-w-[25%]">
            <input type="number" class="tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-w-full"
              formControlName="quantity">
            <span class="tw-label-2 tw-text-danger"
              *ngIf="stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.touched">
              Quantity is
              required</span>
            <span class="tw-label-2 tw-text-danger"
              *ngIf="!stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.hasError('target') && stocks.get('quantity')?.touched">
              {{stocks.get('quantity')?.errors.target}}
            </span>
          </div>
          <div class="tw-w-[15%]">
            <p class="tw-text-right tw-text-color-1 tw-para-1">{{stocks.controls['scriptType'].value}}</p>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="(allInstruments | isExternalDialogCategoryAvailable:{section: data.section, category: 'gold'})">
      <ng-container formArrayName="gold" *ngFor="let stocks of getControlsArr('gold')?.controls; let i = index">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-y-5">
          <p class="tw-para-2 tw-w-[35%]">Gold</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Price</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Quantity</p>
          <p class="tw-para-2 tw-w-[15%] tw-text-right">Order Type</p>
        </div>
        <div class="tw-flex tw-w-full tw-items-center tw-gap-x-5 tw-pb-5 tw-border-b tw-border-b2" [formGroupName]="i">
          <h6 class="tw-w-[35%] tw-text-color-1">{{stocks.controls['tradingSymbol'].value}}</h6>
          <div class="tw-w-[25%] tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-text-color-2">
            {{stocks.controls['currentPrice'].value}}
          </div>
          <div class="tw-w-[25%]">
            <input type="number" class="tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-w-full"
              formControlName="quantity">
            <span class="tw-label-2 tw-text-danger"
              *ngIf="stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.touched">
              Quantity is
              required</span>
            <span class="tw-label-2 tw-text-danger"
              *ngIf="!stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.hasError('target') && stocks.get('quantity')?.touched">
              {{stocks.get('quantity')?.errors.target}}
            </span>
          </div>
          <div class="tw-w-[15%]">
            <p class="tw-text-right tw-text-color-1 tw-para-1">{{stocks.controls['scriptType'].value}}</p>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="(allInstruments | isExternalDialogCategoryAvailable:{section: data.section, category: 'etf'})">
      <ng-container formArrayName="etf" *ngFor="let stocks of getControlsArr('etf')?.controls; let i = index">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-y-5">
          <p class="tw-para-2 tw-w-[35%]">ETF</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Price</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Quantity</p>
          <p class="tw-para-2 tw-w-[15%] tw-text-right">Order Type</p>
        </div>
        <div class="tw-flex tw-w-full tw-items-center tw-gap-x-5 tw-pb-5 tw-border-b tw-border-b2" [formGroupName]="i">
          <h6 class="tw-w-[35%] tw-text-color-1">{{stocks.controls['tradingSymbol'].value}}</h6>
          <div class="tw-w-[25%] tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-text-color-2">
            {{stocks.controls['currentPrice'].value}}
          </div>
          <div class="tw-w-[25%]">
            <input type="number" class="tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-w-full"
              formControlName="quantity">
            <span class="tw-label-2 tw-text-danger"
              *ngIf="stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.touched">
              Quantity is
              required</span>
            <span class="tw-label-2 tw-text-danger"
              *ngIf="!stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.hasError('target') && stocks.get('quantity')?.touched">
              {{stocks.get('quantity')?.errors.target}}
            </span>
          </div>
          <div class="tw-w-[15%]">
            <p class="tw-text-right tw-text-color-1 tw-para-1">{{stocks.controls['scriptType'].value}}</p>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="(allInstruments | isExternalDialogCategoryAvailable:{section: data.section, category: 'mutual_fund'})">
      <ng-container formArrayName="mutual_fund"
        *ngFor="let stocks of getControlsArr('mutual_fund')?.controls; let i = index">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-y-5">
          <p class="tw-para-2 tw-w-[35%]">Mutual Fund</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Price</p>
          <p class="tw-para-2 tw-w-[25%] tw-text-center">Quantity</p>
          <p class="tw-para-2 tw-w-[15%] tw-text-right">Order Type</p>
        </div>
        <div class="tw-flex tw-w-full tw-items-center tw-gap-x-5 tw-pb-5 tw-border-b tw-border-b2" [formGroupName]="i">
          <h6 class="tw-w-[35%] tw-text-color-1">{{stocks.controls['tradingSymbol'].value}}</h6>
          <div class="tw-w-[25%] tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-text-color-2">
            {{stocks.controls['currentPrice'].value}}
          </div>
          <div class="tw-w-[25%]">
            <input type="number" class="tw-border tw-border-b2 tw-rounded tw-bg-primary-10 tw-p-2.5 tw-para-2 tw-w-full"
              formControlName="quantity">
            <span class="tw-label-2 tw-text-danger"
              *ngIf="stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.touched">
              Quantity is
              required</span>
            <span class="tw-label-2 tw-text-danger"
              *ngIf="!stocks.get('quantity')?.hasError('required') && stocks.get('quantity')?.hasError('target') && stocks.get('quantity')?.touched">
              {{stocks.get('quantity')?.errors.target}}
            </span>
          </div>
          <div class="tw-w-[15%]">
            <p class="tw-text-right tw-text-color-1 tw-para-1">{{stocks.controls['scriptType'].value}}</p>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </form>
  <div
    class="tw-flex tw-w-[calc(100%-32px)] tw-bg-surface-10 tw-pt-4 tw-border-t tw-border-b2 tw-absolute tw-justify-center tw-items-center tw-bottom-0">
    <pickright-button type="fill" text="Submit" class="tw-w-80 tw-p-2"
      (btnClick)="confirmInvestment()"></pickright-button>
  </div>
</div>